export default __webpack_public_path__ + "static/media/UiWarn.42959707.svg";